import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";

const MyUploadTab = ({ userData, setUserData }) => {
  const fileInputRef = useRef(null);
  const [uploads, setUploads] = useState([]);

  // revoke objectURLs on unmount
  useEffect(() => {
    return () => {
      uploads.forEach((u) => {
        try {
          URL.revokeObjectURL(u.url);
        } catch (e) {}
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const created = files.map((file) => {
      const url = URL.createObjectURL(file);
      return {
        id: `${file.name}_${Date.now()}_${Math.random()
          .toString(36)
          .slice(2, 7)}`,
        name: file.name,
        url,
        type: file.type,
        size: file.size,
        uploadedAt: new Date().toISOString(),
      };
    });

    setUploads((prev) => [...created, ...prev]);

    // optionally update usedStorage (demo)
    const extraMB = created.reduce(
      (s, f) => s + Math.round(f.size / (1024 * 1024)),
      0
    );
    setUserData((u) => ({ ...u, usedStorage: u.usedStorage + extraMB }));
  };
  const removeUpload = (id) => {
    setUploads((prev) => {
      const toRemove = prev.find((p) => p.id === id);
      if (toRemove) URL.revokeObjectURL(toRemove.url);
      return prev.filter((p) => p.id !== id);
    });
  };
  return (
    <div>
      <h2 className="section-title">
        <FontAwesomeIcon icon={faCloudUploadAlt} /> My Uploads
      </h2>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-value">{uploads.length}</div>
          <div className="stat-label">Total Uploads</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{userData.usedStorage} MB</div>
          <div className="stat-label">Used Storage</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">
            {userData.storageLimit - userData.usedStorage} MB
          </div>
          <div className="stat-label">Remaining Storage</div>
        </div>
      </div>

      <div className="upload-container">
        <input
          ref={fileInputRef}
          id="fileInput"
          type="file"
          accept="image/*,video/*"
          multiple
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />
        <label
          htmlFor="fileInput"
          className="upload-btn"
          onClick={() => fileInputRef.current?.click()}
        >
          Upload Files
        </label>
      </div>

      <div className="upload-preview">
        {uploads.map((f) => (
          <div className="preview-item" key={f.id}>
            {f.type.startsWith("image") ? (
              <img src={f.url} alt={f.name} />
            ) : (
              <video src={f.url} controls />
            )}
            <span
              className="preview-remove"
              title="Remove"
              onClick={() => removeUpload(f.id)}
            >
              ✕
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyUploadTab;
